import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "emoji-flushed",
  "use": "emoji-flushed-usage",
  "viewBox": "0 0 88 88",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 88 88\" id=\"emoji-flushed\">\n  <path d=\"M35 59h18v6H35z\" />\n  <path fill=\"currentColor\" d=\"M53 29h18v18H53zm-36 0h18v18H17z\" />\n  <path d=\"M59 35h6v6h-6zm-36 0h6v6h-6z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol